import { LearningItem } from "./types";

export const colors: LearningItem[] = [
  {
    id: "red",
    label: "Red",
    word: "Red",
    model: "/models/red.glb",
    audio: "/audio/red.mp3",
    color: "#ef4444",
    category: "color",
  },
  {
    id: "blue",
    label: "Blue",
    word: "Blue",
    model: "/models/blue.glb",
    audio: "/audio/blue.mp3",
    color: "#3b82f6",
    category: "color",
  },
  {
    id: "green",
    label: "Green",
    word: "Green",
    model: "/models/green.glb",
    audio: "/audio/green.mp3",
    color: "#10b981",
    category: "color",
  },
  {
    id: "yellow",
    label: "Yellow",
    word: "Yellow",
    model: "/models/yellow.glb",
    audio: "/audio/yellow.mp3",
    color: "#fbbf24",
    category: "color",
  },
  {
    id: "orange",
    label: "Orange",
    word: "Orange",
    model: "/models/orange.glb",
    audio: "/audio/orange.mp3",
    color: "#f97316",
    category: "color",
  },
  {
    id: "purple",
    label: "Purple",
    word: "Purple",
    model: "/models/purple.glb",
    audio: "/audio/purple.mp3",
    color: "#8b5cf6",
    category: "color",
  },
];

